import { _object } from 'utils/interfaces'
import { generateQueryParams } from 'utils'

import CommonService from './common.service'

class SliderService extends CommonService {
  async getSliders(params: _object) {
    return await this.get(`/sliders?${generateQueryParams(params)}`)
  }

  async getSliderDetails(id: string | undefined) {
    return await this.get(`/sliders/${id}`)
  }

  async addSlider(params: { [key: string]: string }) {
    return await this.post('/sliders', params)
  }

  async updateSlider(id: string | undefined, params: _object) {
    return await this.put(`/sliders/${id}`, params)
  }

  async deleteSlide(id: string) {
    return await this.delete(`/sliders/${id}`)
  }
}

export const sliderService = new SliderService()
